import { z } from "zod";
import { dateStringSchema } from "./common.js";
export const clusterRunSchema = z.object({
    id: z.number(),
    networkId: z.string(),
    algorithm: z.string(),
    // jsonb blob (ClusterRunParams) — passed through untyped; TS interfaces
    // without index signatures aren't assignable to z.record inputs.
    params: z.unknown().nullable(),
    numClusters: z.number().nullable(),
    numOutliers: z.number().nullable(),
    // `centroids` is deliberately NOT declared — it's a large internal analysis
    // blob (per-cluster feature centroids + ranges) that no client reads; the
    // serializer strips it from run rows.
    computedAt: dateStringSchema,
});
export const clusterSizeSchema = z.object({
    clusterId: z.number(),
    count: z.union([z.string(), z.number()]),
    avgOutlierScore: z.number().nullable(),
    maxOutlierScore: z.number().nullable(),
});
export const clusterRunDetailResponseSchema = z.object({
    run: clusterRunSchema,
    clusterSizes: z.array(clusterSizeSchema),
});
export const umapClusterSchema = z.object({
    clusterId: z.number(),
    cx: z.number(),
    cy: z.number(),
    cz: z.number(),
    count: z.number(),
});
export const umapOutlierSchema = z.object({
    x: z.number(),
    y: z.number(),
    z: z.number(),
    txHash: z.string(),
    outlierScore: z.number().nullable(),
});
export const umapDataResponseSchema = z.object({
    runId: z.number(),
    clusters: z.array(umapClusterSchema),
    outliers: z.array(umapOutlierSchema),
});
export const clusterMemberSchema = z.object({
    txId: z.number(),
    txHash: z.string(),
    status: z.string(),
    membershipScore: z.number().nullable(),
    outlierScore: z.number().nullable(),
    blockNumber: z.number().nullable(),
    numNoteHashes: z.number(),
    numNullifiers: z.number(),
    numL2ToL1Msgs: z.number(),
    numPrivateLogs: z.number(),
    numContractClassLogs: z.number(),
    numPublicLogs: z.number().nullable(),
    gasLimitDa: z.number().nullable(),
    gasLimitL2: z.number().nullable(),
    maxFeePerDaGas: z.number().nullable(),
    maxFeePerL2Gas: z.number().nullable(),
    numSetupCalls: z.number(),
    numAppCalls: z.number(),
    hasTeardown: z.boolean(),
    totalPublicCalldataSize: z.number(),
    expirationTimestamp: z.number().nullable(),
    feePayer: z.string(),
});
export const clusterMembersResponseSchema = z.object({
    clusterId: z.number(),
    members: z.array(clusterMemberSchema),
});
export const outlierEntrySchema = z.object({
    txId: z.number(),
    txHash: z.string(),
    outlierScore: z.number().nullable(),
    clusterId: z.number(),
    clusterSize: z.number(),
    blockNumber: z.number().nullable(),
    numNoteHashes: z.number(),
    numNullifiers: z.number(),
    numPublicDataWrites: z.number().nullable(),
    numPrivateLogs: z.number(),
    numPublicLogs: z.number().nullable(),
});
export const outliersResponseSchema = z.object({
    runId: z.number(),
    totalTxsAnalyzed: z.number(),
    outliers: z.array(outlierEntrySchema),
});
// Param schemas
export const runIdParamSchema = z.object({
    id: z.string(),
    runId: z.string(),
});
export const clusterIdParamSchema = z.object({
    id: z.string(),
    runId: z.string(),
    clusterId: z.string(),
});
export const outliersQuerySchema = z.object({
    limit: z.string().optional(),
});
//# sourceMappingURL=clusters.js.map